module.exports = __webpack_public_path__ + "img/icon-16.80df5d15.png";